import React from 'react'
import type { MailgunEvent } from '@ztechapps/common.contract'
import { LocalDateTime } from '@ztechapps/webui.date'
import { humanize, truncate } from '@ztechapps/common.utils'
import { HorizontalStack, Icon, JsonViewer, Scrollable, TooltipPopOver } from '@ztechapps/webui.util'
import { RichTextDisplay } from '@ztechapps/webui.input'
import type { BodyRowConfig } from '../../DataTable/types'
import { useTableBody } from '../../DataTable/hooks/useTableBody'
import { ExtendingRow } from '../../Table/extending-row'

export const MailgunEventListRow = (props: BodyRowConfig<MailgunEvent>) => {
  const { metadata } = props
  const extensionRow = <Extension {...{ metadata }} />

  const { renderDataBodyCell, onRowClick, highlightClassName } = useTableBody(props, props._index)
  return (
    <ExtendingRow
      {...{ ...props, colSpan: 20, extensionRow }}
      _config={{
        onSelect: onRowClick,
        highlightClassName,
      }}
    >
      <DataListRow {...props} _renderDataBodyCell={renderDataBodyCell} />
    </ExtendingRow>
  )
}

const Extension = ({ metadata }: { metadata: Record<any, any> }) => {
  return <JsonViewer data={metadata} collapsed={false} />
}

const DataListRow = (props: BodyRowConfig<MailgunEvent>) => {
  const { timeStamp, event, bodyHtml, bodyPlain } = props

  return (
    <>
      {props._renderDataBodyCell({
        timeStamp: <LocalDateTime value={timeStamp} />,
        event: humanize(event),
        bodyPlain: (
          <HorizontalStack gap={1}>
            <TooltipPopOver
              showHeader
              placement={'bottom'}
              flip
              tooltipBody={
                <Scrollable height="300px">
                  <div style={{ maxWidth: '65vh' }}>
                    {/* trustedSource: this is the body of an email WE sent (Mailgun's delivery-event
                        webhook echoes it back) — every MailgunEventTypeEnum value describes an outbound
                        send's outcome, never an inbound message, so it is not attacker-reachable */}
                    <RichTextDisplay contentHtml={bodyHtml ?? bodyPlain} className={''} trustedSource />
                  </div>
                </Scrollable>
              }
            >
              <div className={'text-primary'}>
                <Icon name="info-circle" />
              </div>
            </TooltipPopOver>
            <div>{truncate(bodyPlain, 150)}</div>
          </HorizontalStack>
        ),
      })}
    </>
  )
}
